import { render, staticRenderFns } from "./vs-dialog.vue?vue&type=template&id=7b066d5a"
import script from "./vs-dialog.vue?vue&type=script&lang=js"
export * from "./vs-dialog.vue?vue&type=script&lang=js"
import style0 from "./vs-dialog.vue?vue&type=style&index=0&id=7b066d5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports